export default __webpack_public_path__ + "static/media/30min.eb6e7865.svg";